import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const generateIconsClassNames = ({ size, extraClass, iconExtraClass }) => classNames('icon', {
  [`icon--${size}`]: size,
  [`${extraClass}`]: extraClass,
  [`${iconExtraClass}`]: iconExtraClass,
});

// TODO: [4] Find a better way to pass extra classes to Icon
const Icon = ({
  size,
  extraClass,
  iconExtraClass,
  iconSrc,
  alt = '',
  testAttribute,
  width,
  height,
  loading,
}) => (
  <picture>
    <img
      loading={loading}
      className={generateIconsClassNames({ size, extraClass, iconExtraClass })}
      alt={alt}
      src={iconSrc}
      size={size}
      data-test={testAttribute}
      width={width}
      height={height || width}
    />
  </picture>
);

Icon.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  extraClass: PropTypes.string,
  iconExtraClass: PropTypes.string,
  iconSrc: PropTypes.string,
  alt: PropTypes.string,
  testAttribute: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  loading: PropTypes.oneOf(['lazy', 'eager']),
};

export default Icon;
